import { BaseMultiTenantService } from '../base/BaseMultiTenantService';
import { PostgrestResponse } from '@supabase/supabase-js';
import { IVwProdutosMaisVendidos } from '../../../types/views/IVwProdutosMaisVendidos';

/**
 * View para produtos mais vendidos
 * Corresponde à view 'vw_produtos_mais_vendidos' no banco de dados
 */
export class ViewProdutosMaisVendidos extends BaseMultiTenantService<IVwProdutosMaisVendidos> {
     constructor() {
          super('vw_produtos_mais_vendidos', [], 'organizacao');
     }

     /**
      * Lista produtos mais vendidos
      */
     async getProdutosMaisVendidos(organizationId: number, limite: number = 10): Promise<PostgrestResponse<IVwProdutosMaisVendidos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .order('quantidade_total', { ascending: false })
               .limit(limite);
     }

     /**
      * Produtos por faturamento
      */
     async getProdutosPorFaturamento(organizationId: number, limite: number = 10): Promise<PostgrestResponse<IVwProdutosMaisVendidos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .order('faturamento_total', { ascending: false })
               .limit(limite);
     }

     /**
      * Produtos por categoria mais vendidos
      */
     async getProdutosPorCategoria(organizationId: number, categoria: string): Promise<PostgrestResponse<IVwProdutosMaisVendidos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .ilike('produto', `%${categoria}%`)
               .order('quantidade_total', { ascending: false });
     }

     /**
      * Ranking completo de produtos
      */
     async getRankingCompleto(organizationId: number): Promise<PostgrestResponse<IVwProdutosMaisVendidos[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .order('quantidade_total', { ascending: false });
     }

     /**
      * Produtos vendidos hoje
      */
     async getProdutosVendidosHoje(organizationId: number): Promise<PostgrestResponse<IVwProdutosMaisVendidos[]>> {
          const hoje = new Date().toISOString().split('T')[0];
          
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .gte('ultima_venda', hoje)
               .order('quantidade_total', { ascending: false });
     }
}

export const viewProdutosMaisVendidos = new ViewProdutosMaisVendidos();
